import Store from '@ember-data/store';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { ComponentArgs } from 'donor-elf-web/components/journal/dashboard/index';
import DashboardModel from 'donor-elf-web/models/dashboard';
import FundsService from 'donor-elf-web/services/funds-service';

export default class JournalDashboardUcoComponent extends Component<ComponentArgs> {
  @service declare fundsService: FundsService;
  @service declare store: Store;

  @tracked mainDashboard!: DashboardModel;
  @tracked loading = true;

  get dashboardGoal() {
    return this.mainDashboard?.goal;
  }

  get dashboardGoalData() {
    return this.dashboardGoal?.goalData;
  }

  // taken from app/controllers/funds/fund/dashboard/ytd.ts
  get leftToRaiseAmount() {
    if (this.dashboardGoal == null || this.dashboardGoalData == null) {
      return 0;
    }
    let leftToRaise =
      this.dashboardGoal.goalAmount -
      this.dashboardGoalData.given_amount -
      this.dashboardGoalData.expected_amount;
    if (leftToRaise < 0) {
      leftToRaise = 0;
    }
    return leftToRaise;
  }

  @action
  async load() {
    this.loading = true;
    this.mainDashboard = await this.store.findRecord(
      'dashboard',
      this.fundsService.selectedFund!.id,
    );
    this.loading = false;
  }
}
